import { baseApi } from "@/shared/api";
import type { DepreciationReport } from "@/features/accounting/financial-reports/types";

interface DepreciationReportParams {
  report_date: string;
}

export const depreciationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDepreciationReport: builder.query<DepreciationReport, DepreciationReportParams>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        searchParams.set("report_date", params.report_date);
        return {
          url: `/api/warehouse/depreciation-report/?${searchParams.toString()}`,
          method: "GET",
          credentials: "include" as const,
        };
      },
      providesTags: [{ type: "Reports" as const, id: "DEPRECIATION_REPORT" }],
    }),
  }),
});

export const { useGetDepreciationReportQuery } = depreciationApi;
